(function () {
    'use strict';

    angular
        .module('bcmModule')
        .controller('bcmBiaProfileSummaryController', Controller);

    Controller.$inject = ['$scope', '$state', '$modal', 'biaProfileService', 'notificationService'];

    function Controller($scope, $state, $modal, biaProfileService, notificationService) {

        /**
         * @property $scope.boxModel -- BIA profile
         * @property $scope.boxContext.BCMLookups {LookupAttributes[]}
         * @property $scope.canValidate {boolean} -- True if user can approve BIA Summary
         * @property $scope.canReject {boolean} -- True if user can reject BIA Summary
         * @property $scope.boxContext.BIABUOwnersContainer {BIABuOwnerContainer[]} -- list of BIABUOwnerContainer
         * @property BIABuOwnerContainer.BIABUOwner -- BIA BU Owner
         * @property BIABuOwnerContainer.BIAResponsibilities {BIAResponsibilities[]} -- BIA BU Owner
         */

        $scope.ctrlCtxt = {
            isLoading: false
        };

        // Approve By Head
        $scope.showValidateModal = function () {
            showValidationModal('validate');
        };

        // Reject By Head
        $scope.showRejectModal = function () {
            showValidationModal('reject');
        };

        function showValidationModal(template) {
            if ($scope.ctrlCtxt.isLoading) return;

            var templateUrl = '/app/shared/BCM/BIAProfile/biaProfileBUOwnerValidation.' + template + '.modal.tpl.html';

            // Display modal
            var modalScope = $scope.$new(true);

            modalScope.ctrlCtxt = {};
            modalScope.biaProfile = $scope.boxModel;
            modalScope.followUp = {
                Comment: null
            };

            var showModal = $modal({
                scope: modalScope,
                template: templateUrl,
                placement: 'center',
                backdrop: 'static'
            });

            // When confirming validation
            modalScope.confirmValidation = function () {
                $scope.ctrlCtxt.isLoading = true;

                biaProfileService
                    .validateByBUOwner($scope.boxModel.BIAProfileID)
                    .then(function () {
                        notificationService.notify('Business Continuity Analysis Validated Successfully');
                        modalScope.close();
                        $state.go('home', { UserItemPersonID: $scope.authenticatedUser.ItemPersonID });
                    })
                    .then(function () {
                        $scope.ctrlCtxt.isLoading = false;
                    });
            };

            // When confirming to reject
            modalScope.confirmReject = function () {
                $scope.ctrlCtxt.isLoading = true;

                biaProfileService
                    .rejectByBUOwner($scope.boxModel.BIAProfileID)
                    .then(function () {
                        // Create Follow-up
                        biaProfileService
                            .createBIAProfileFollowUp($scope.boxModel.BIAProfileID, modalScope.followUp)
                            .then(function () {
                                notificationService.notify('Business Continuity Analysis Rejected Successfully');
                                modalScope.close();
                                $state.go('home', { UserItemPersonID: $scope.authenticatedUser.ItemPersonID });
                            })
                            .then(function () {
                                $scope.ctrlCtxt.isLoading = false;
                            });
                    });
            };

            // Close Modal
            modalScope.close = function () {
                showModal.$promise.then(showModal.hide);
            };
        }
    }
})();